<ng-container *ngIf="(selectedOrganization$ | async) as selectedOrganization">
  <h1 class="__header">{{selectedOrganization.name}}</h1>
  <div class="__header-btn-group">
    <ng-container *ngIf="(isFloorPlanEdited$ | async) &&
    !(saveFloorPlanLoading$ | async) &&
    (saveParams$ | async) as saveParams; else disabledBtn">
      <button class="__save-button"
              (click)="onSave(saveParams)">
        <span class="__button-wrapper">
          <awair-save-icon class="__save-icon" [color]="'#FFFFFF'"></awair-save-icon>
          Save
        </span>
      </button>
    </ng-container>
    <!-- Disabled Button -->
    <ng-template #disabledBtn>
      <button class="__save-button"
              disabled>
        <span class="__button-wrapper">
          <awair-save-icon class="__save-icon" [color]="'#FFFFFF'"></awair-save-icon>
          Save
        </span>
      </button>
    </ng-template>
    <!--/.Disabled Button-->
  </div>
</ng-container>
